export default "__VITE_ASSET__CGpe$XL4__"